<template>
  <div class="arm-arq-ger-informativo">
    <table v-if="Object.keys(dados).length >= 1">
      <tr>  
        <td colspan="2">
          <div class="progress">
            <template v-for="tp in dados">
              <div :key="tp.chave" class="progress-bar" role="progressbar" :style="'width: ' + tp.porcentagem + '%; background: ' + tp.fundo + '; border: 1px solid ' + tp.borda + '; '" :aria-valuenow="tp.porcentagem" aria-valuemin="0" aria-valuemax="100" :title="tp.chave + ': ' + tp.porcentagem + '%'"></div>
            </template>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <span v-html="total.formatado"></span> utilizado em um total de <span v-html="total.qtde"></span> arquivos
        </td>
        <td class="link">
          <a @click="detalhar = !detalhar" style="">Mostrar detalhes de uso</a>
        </td>
      </tr>
      <tr v-if="detalhar === true" class="detalhe">
        <td colspan="2">
          <div>
            <template v-for="tp in dados">
              <div v-if="[ '', null, undefined ].indexOf(tp.porcentagem) === -1" :key="'detalhe-' + tp.chave">
                <div :style="'background: ' + tp.fundo + '; border: 1px solid ' + tp.borda + '; '" class="bola">&nbsp;</div>
                <span v-html="tp.chave + ': '" style="font-weight: bold; text-transform: uppercase;"></span>
                <span v-html="tp.porcentagem + '%'"></span>
                <span v-html="' em um total de ' + tp.qtde + ' arquivo' + (tp.qtde >= 2 ? 's' : '')"></span>
              </div>
            </template>
          </div>
        </td>
      </tr>
    </table>

    <div v-if="Object.keys(lixeira).length >= 1 && [ '', null, undefined ].indexOf(dados.Lixeira) === -1 && dados.Lixeira.qtde >= 1" class="esvaziar-lixeira">
      <RF-Button :data-time="time"
        :cpntId="lixeira.id"
        :cpntStatus='lixeira.status'
        :cpntTipo='lixeira.tipo'
        :cpntIcone='lixeira.icone'
        :cpntTexto='lixeira.texto'
        :cpntClass='lixeira.class'

        @onClickButton='lixeira.onClick'>
      </RF-Button>

      <RF-Dialog v-if="lixeira.aviso === true"
      :cpntStatus='""'
      :cpntLargura='"500px"'
      :cpntTitulo="'Esvaziar Lixeira'"
      :cpntAnimacao="true"
      :cpntOnFecharDialog='lixeira.onClick'>
        <template slot="conteudo">
          <div class="arm-arq-ger-informativo-lixeira">
            <b>ATENÇÃO</b>
            <br/>
            <br/>
            Está operação não poderá ser desfeita.
            <br/>
            <br/>
            <span>
              Será liberado <span v-html="dados.Lixeira.formatado"></span> em um total de <span v-html="dados.Lixeira.qtde"></span> arquivos.
            </span>
            <br/>
            <br/>
            <span>
              Para confirmar a exclusão <span>DEFINITIVA</span> dos arquivos da lixeira,
              
            <br/>
            <br/>
              é necessario informe a senha do seu usuário <span>[<b v-html="$store.state.token.usuario"></b>]</span> abaixo:
            </span>

            <div>
              <RF-Componente v-if="Object.keys(senha).length >= 1"
                :data-time='time'
                :cpntTamanho='senha.tamanho'
                :cpntModelo='senha.tipo'
                :cpntType='senha.type'
                :cpntStatus='senha.status'
                :cpntId='senha.id'
                :cpntClassDivField='senha.classDivField'
                :cpntNome='senha.nome'
                :cpntValue='senha.value'
                :cpntValueRef='senha.valueRef'
                :cpntOptions='senha.options'
                :cpntKeyValue='senha.keyValue'
                :cpntKeyMostra='senha.keyMostra'
                :cpntAutoComplete='senha.autocomplete'
                :cpntDisabled='senha.disabled'
                :cpntMostrar='senha.mostrar'
                :cpntMensagem='senha.mensagem'
                :cpntSelecioneNome='senha.selecioneNome'
                :cpntSelecioneValue='senha.selecioneValue'
                :cpntMensagemTipo='senha.mensagemTipo'
                :cpntAdicinarOption='senha.adicinarOption'
                :cpntMultiple='senha.multiple'
                :cpntAllRegistro='senha.allRegistro'
                :cpntExplica='senha.explica'
                :cpntConfig='senha.config'
                :cpntTabIndex='senha.tabIndex'
                :cpntMaxLength='senha.maxLength'
                :cpntOptionInicialNome='senha.optionInicialNome'
                :cpntOptionInicialValue='senha.optionInicialValue'

                :cpntOnChange='senha.onChange'
                :cpntOnKeyPressEnter='senha.onKeyPressEnter'
                :cpntOnBlur='senha.onBlur'
                :ref='senha.id'
              ></RF-Componente>

              <RF-Button v-if="Object.keys(confirma).length >= 1"
                :data-time="time"
                :cpntId='confirma.id'
                :cpntStatus='confirma.status' 
                :cpntTexto='confirma.texto' 
                :cpntClass="confirma.class"

                @onClickButton='confirma.onClick'
              ></RF-Button>
            </div>
          </div>
        </template>
      </RF-Dialog>
    </div>

    <!-- <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <button @click="teste">teste</button>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/> -->
  </div>
</template>

<style scoped>
  .arm-arq-ger-informativo {
    padding-bottom: 10px;
    min-height: 55px;
  }
    .arm-arq-ger-informativo > table {
      width: 100%;
      max-width: 850px;
      margin: 0px auto;
      
      border-collapse: separate;
      border-spacing: 1px;
    }
      .arm-arq-ger-informativo > table > tr > td.link {
        text-align: right;
      }
        .arm-arq-ger-informativo > table > tr > td.link > a {
          cursor: pointer;
        }
      .arm-arq-ger-informativo > table > tr > td > .progress {
        margin-bottom: 0px;
      }
      .arm-arq-ger-informativo > table > tr.detalhe > td > div {
        text-align: center;
        background: #fafafa;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 5px;
      }
        .arm-arq-ger-informativo > table > tr.detalhe > td > div > div {
          margin: 5px;
          display: inline-block;
        }
          .arm-arq-ger-informativo > table > tr.detalhe > td > div > div > .bola {
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 10px;
            margin-right: 5px;
          }
      .arm-arq-ger-informativo > table > tr.detalhe > td > div {
        margin-top: 10px;
      }

  .esvaziar-lixeira {
    float: right;
    margin: -35px 0px 10px 10px;
  }

  .arm-arq-ger-informativo-lixeira {
    text-align: center;
  }
    .arm-arq-ger-informativo-lixeira > b {
      font-size: 16px;
    }
    .arm-arq-ger-informativo-lixeira > span > span {
      font-style: italic;
      text-decoration: underline;
    }

    .arm-arq-ger-informativo-lixeira > div {
      margin: 15px 0px
    }
</style>

<style>
  .arm-arq-ger-informativo-lixeira > div > div {
    display: inline-block;
  }
    .arm-arq-ger-informativo-lixeira > div > div > div > input {
      border: 1px solid #CCC !important;
      border-radius: 5px;
      padding: 6px 5px !important;
    }
    .arm-arq-ger-informativo-lixeira > div > div > input {
    }
  .arm-arq-ger-informativo-lixeira > div > button {
    margin-top: -3px;
    margin-left: 10px;
  }
</style>

<script>
export default {
  props: {
    cpntReiniciar: {
      required: true
    }
  },
  data: function () {
    return {
      time: '',
      statusGeral: '',
      detalhar: false,
      dados: {},
      lixeira: {},
      senha: {},
      confirma: {},
      total: {}
    }
  },
  mounted: function () {
    this.armArqGerGraficoIniciar()
  },
  methods: {
    // teste: function () {
    //   // var retorno = JSON.parse('{"titulo":"Buscar Contato","callback":"responsavel_Callback2|0","tipo":"BUSCAR_CADASTRO","tpCadastro":"contato","chave":"_3205"}')

    //   // // PEGA O NOME DA AÇÃO RECEBIDA
    //   // retorno.tipo = retorno.acao.substring(6, retorno.acao.length)
      
    //   // // INICIA O VALOR SE ELE NÃO EXISTIR
    //   // retorno.button = [ '', null, undefined ].indexOf(retorno.button) !== -1 ? false : retorno.button
    //   // retorno.tabela = [ '', null, undefined ].indexOf(retorno.tabela) !== -1 ? false : retorno.tabela

    //   // retorno.callback = function (atualizar, id, dados) {
    //   //   console.error(atualizar, id, dados)
    //   // }

    //   // var params = { acao: 'FINANCEIRO_EDITAR_BOLETO', id: '' }

    //   // // CHAMA FUNÇÃO PARA ATUALIZAR INFORMAÇOES DO MENU
    //   // this.$store.commit('SET_ABRIR_LOG', params)

    //   // SETA OS PARAMETROS PARA INICIAR
    //   var params = { tipo: 'FINANCEIRO_EDITAR_BOLETO', id: '1073' }

    //   // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
    //   this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
    // },
    armArqGerGraficoIniciar: function () {
      var self = this

      // SETA O STATUS DA PAGINA
      self.armArqGerGraficoSetarStatusGeral('carregando')

      // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS PARA O GRAFICO
      self.armArqGerGraficoBuscarRegistros()

      // SETA OS DADOS PARA O BOTÃO
      if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 30 ], null, [ 54 ], null, [ 573 ], null, false) === true) {
        self.lixeira = {
          status: '',
          id: 'arm-arq-ger-grafico--lixeira',
          tipo: 'icone-texto',
          texto: 'Esvaziar Lixeira',
          icone: { tipo: 'far fa-trash-alt' },
          aviso: false,
          senha: '',
          onClick: self.armArqGerGraficoEsvaziarLixeira
        }

        self.senha = {
          tamanho: 57,
          status: '',
          id: 'arm-arq-ger-grafico--senha',
          tipo: 'input',
          type: 'password',
          value: '',
          onChange: function (value) {
            // SETA O VALOR RECEBIDO
            self.senha.value = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          },
          onKeyPressEnter: self.armArqGerGraficoEsvaziarLixeira
        }

        self.confirma = {
          status: '',
          id: 'arm-arq-ger-grafico--confirm',
          texto: 'Confirmar',
          class: [ 'btn', 'btn-primary', 'btn-sm' ],
          onClick: self.armArqGerGraficoEsvaziarLixeira
        }
  
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()
      }
    },
    armArqGerGraficoSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    armArqGerGraficoBuscarRegistros: function (registro = [], total = null) {
      var self = this

      if (total === null || registro.length < total) {
        // CHAMA A FUNÇÃO PARA CALCULAR OS TAMANHOS
        var queryGet = { type: 'list', limit: { row: registro.length, qty: 1000 }, field: { size_bytes_total: { o: 'sum' }, ext: { o: 'count' }, status: null } }

        // SETA O AGRUPAMENTO DOS REGISTROS
        queryGet.group = [ 'status', 'ext' ]
  
        // FAZ A BUSCA NA API
        self.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, function (apiSuccess) {
          // JUNTA OS VALORES RECEBIDOS
          registro = registro.concat(apiSuccess.data)

          // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS ARQUIVOS
          self.armArqGerGraficoBuscarRegistros(registro, Number(apiSuccess.countAll))
        }, self.armArqGerGraficoSetarStatusGeral)
      } else {
        self.armArqGerGraficoMontar(registro)
      }
    },
    armArqGerGraficoMontar: function (registro) {
      var self = this

      // INICIA O VETOR QUE VAI ORGANIZAR PARA O GRAFICO
      var vetor = { Lixeira: { qtde: 0, tamanho: 0 } }
      self.total = { qtde: 0, tamanho: 0 }

      // CALCULA O TAMANHO ENCONTRADO
      for (var key in registro) {
        if (registro[key].status !== '1') {
          // SOMA A QUANTIDADE DE ARQUIVOS EXCLUIDOS
          vetor.Lixeira.qtde += Number(registro[key].ext_count)

          // SOMA O TAMANHO TOTAL
          vetor.Lixeira.tamanho += Number(registro[key].size_bytes_total_sum)
        } else {  
          // VERIFICA SE O VALOR JÁ EXISTE
          if ([ '', null, undefined ].indexOf(vetor[registro[key].ext]) !== -1) {
            vetor[registro[key].ext] = { qtde: 0, tamanho: 0 }
          }

          // SOMA A QUANTIDADE DE ARQUIVOS
          vetor[registro[key].ext].qtde += Number(registro[key].ext_count)

          // SOMA O TAMANHO TOTAL ENCONTRADO PARA EXTENSÃO
          vetor[registro[key].ext].tamanho += Number(registro[key].size_bytes_total_sum)          
        }

        // SOMA A QUANTIDADE DE ARQUIVOS TOTAL
        self.total.qtde += Number(registro[key].ext_count)

        // SOMA O TAMANHO TOTAL ENCONTRADO
        self.total.tamanho += Number(registro[key].size_bytes_total_sum)
      }

      // REMOVE A CHAVE LIXEIRA QUE ESTÁ VAZIA
      if (vetor.Lixeira.qtde === 0) {
        delete vetor.Lixeira
      } else {
        // ADICIONA NA ULTIMA OPÇÃO 
        vetor._Lixeira = JSON.parse(JSON.stringify(vetor.Lixeira))

        // REMOVE A CHAVE ANTIGA 
        delete vetor.Lixeira

        // ADICIONA NA ULTIMA OPÇÃO 
        vetor.Lixeira = JSON.parse(JSON.stringify(vetor._Lixeira))

        // REMOVE A CHAVE ANTIGA 
        delete vetor._Lixeira
      }

      // INICIA A VARIAVEL PARA CALCULAR A PORCENTAGEM TOTAL
      var total = 0

      // INICIA O VETOR
      var dependentes = {}

      // MONTA OS VETORES
      for (var index in vetor) {
        // SETA A CHAVE
        vetor[index].chave = index.toUpperCase()

        // CONVERTE O NOME DO ARQUIVO PARA MAIUSCULO
        vetor[index].nome = [ 'Total', 'Lixeira' ].indexOf(index) === -1 ? index.toUpperCase() : index

        // CALCULA A PORCENTAGEM
        vetor[index].porcentagem = Number((((vetor[index].tamanho - self.total.tamanho) / self.total.tamanho * 100) + 100).toFixed(2))

        // SOMA A PORCENTAGEM TOTAL
        total += vetor[index].porcentagem

        // SETA A CHAVE PARA BUSCAR A COR
        dependentes[index] = []

        // FORMATA O TAMANHO
        vetor[index].formatado = self.armArqGerGraficoConverterTamanhoArq(vetor[index].tamanho)
      }

      // INICIA O VETOR DE DEPENDENTES
      var vetBuscaCores = {}

      // MONTA O VETOR DE DEPENDETES
      for (var indexC in dependentes) {
        vetBuscaCores[indexC] = function (chave, callback) {
          // IMPORTA A FUNÇÃO DEPENDENTE
          const FUN_PEGAR_CORES = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CORES

          // CRIA AS CORES PARA CHAVE INFORMADA
          FUN_PEGAR_CORES(chave, function (cores) {
            // JUNTA OS VALORES RECEBIDOS
            vetor[chave] = Object.assign(vetor[chave], cores)
            
            // EXECUTA A FUNÇÃO CALLBACK PARA FINALIZAR ESSE PROCESSO
            callback(chave)
          })
        }
      }

      // PEGA OS DEPENDENTES PARA FUNÇÃO FINALIZAR
      dependentes.finalizar = Object.keys(dependentes)

      // SETA A FUNÇÃO FINAL
      vetBuscaCores.finalizar = function (chave, callback, self) {
        // VEIFICA SE TEM DIFERENÇA NO TOTAL CALCULADO
        if (total > 100) {
          vetor[index].porcentagem = vetor[index].porcentagem - Number((total - 100).toFixed(2))
        }
  
        // INICIA O VETOR PARA RECEBER OS DADOS
        self.dados = vetor
  
        // FORMATA O TAMANHO
        self.total.formatado = self.armArqGerGraficoConverterTamanhoArq(self.total.tamanho)
  
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()
      }

      // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
      const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

      // EXECUTA A FUNÇÃO DE CALLBACKS
      FUN_TRATAR_RETONOS_E_CALLBACK(self, dependentes, vetBuscaCores)
    },
    armArqGerGraficoConverterTamanhoArq: function (bytes) {
      // SETA OS TIPOS DE TAMANHOS
      var sizes = [ 'Bytes', 'KB', 'MB', 'GB', 'TB' ]

      // VERIFICAI O TAMANHO RECEBIDO É VALIDO
      if (bytes == 0) {
        return '0 Byte'
      }

      // CONVERTE O VALOR RECEBIDO
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))

      // RETORNA O VALOR MONTADO
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },
    armArqGerGraficoEsvaziarLixeira: function (atualizar = '') {
      if (atualizar === false || this.lixeira.aviso === false) {
        // MOSTRA O AVISO 
        this.lixeira.aviso = !this.lixeira.aviso

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // DA FOCUS NO CAMPO
        this.armArqGerGraficoRealizarFocusCampos(this.senha.id)
      } else if (this.lixeira.aviso === true) {
        var self = this

        // SETA O STATUS
        self.armArqGerGraficoSetarStatusButtons('carregando')

        // CRIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var queryGet = { type: 'list', return: 'arrayGroupByField', field: { id: null } }

        //  SETA O WHERE DA CONSULTA
        queryGet.where = { aAnd: [ { f: 'status', o: 'isNull' } ] }

        // FAZ A COMUNICAÇÃO COM A API
        self.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, function (apiSuccess) {
          // PEGA O RETORNO E CONVERTE EM ARRAY
          var ids = apiSuccess.data.id.split(',')

          // REMOVE OS VALORES INVALIDOS
          ids = ids.filter(item => [ '', null, undefined ].indexOf(item) === -1)

          // VERIFICA SE TEM ALGUMA COISA PARA EXCLUIR
          if (ids.length === 0) {
            // APRESENTA A MENSAGEM DE ERRO
            self.$store.state.msgWarn('WEB [406]: Não existe arquivos para serem deletados DEFINITIVAMENTE do Rotina Fácil.', 'warning')

            // CHAMA A FUNÇÃO PARA INICIAR A TELA NOVAMENTE
            if ([ '', null, undefined ].indexOf(self.cpntReiniciar) === -1) {
              self.cpntReiniciar()
            }
          } else {
            // // CONVERTE PARA NUMERO O VALOR ENCONTRADO
            // for (var i in ids) {
            //   ids[i] = Number(ids[i])
            // }

            // CRIA O FORMULARIO QUE SERÁ ENVIADO PARA API
            var formData = { j_id: ids, senha: self.senha.value }
  
            // FAZ A COMUNICAÇÃO COM A API
            self.$store.state.comunicaAPI('/arm-arquivo/definitivo', 'DELETE', formData, function (apiSuccess) {
              // TRATA A MENSAGEM RECEBIDA
              self.$store.state.TRATAR_RET_LOT_API(apiSuccess, null, 'API [200]: Arquivo(s) excluído(s) definitivamente com sucesso.')
  
              // CHAMA A FUNÇÃO PARA INICIAR A TELA NOVAMENTE
              if ([ '', null, undefined ].indexOf(self.cpntReiniciar) === -1) {
                self.cpntReiniciar()
              }
            }, function (apiError) {
              // SETA O STATUS DO BUTOTN
              self.armArqGerGraficoSetarStatusButtons('')

              // DA FOCUS NO CAMPO
              self.armArqGerGraficoRealizarFocusCampos(self.senha.id)

              // SETA O STATUS DA TELA
              self.armArqGerGraficoSetarStatusGeral(apiError)
            }, function (apiValid, apiStatus) {
              self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, {}, true, function () {
                // SETA O STATUS DO BUTOTN
                self.armArqGerGraficoSetarStatusButtons('')

                // DA FOCUS NO CAMPO
                self.armArqGerGraficoRealizarFocusCampos(self.senha.id)
              })
            })
          }
        }, self.armArqGerGraficoSetarStatusGeral)
      }
    },
    armArqGerGraficoSetarStatusButtons: function (status) {
      // SETA O STATUS DA LIXEIRA
      this.lixeira.status = status === 'carregando' ? 'carregando' : ''

      // SETA O STATUS DA CONFIRME
      this.confirma.status = status

      // DESABILITA O CAMPO SENHA
      this.senha.disabled = status === 'carregando'
      
      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    armArqGerGraficoRealizarFocusCampos: function (campo, tentativa = 0) {
      if ([ '', null, undefined ].indexOf(campo) === -1) {
        var self = this

        setTimeout(function () {
          if ([ '', null, undefined ].indexOf(self.$refs[campo]) === -1 && [ '', null, undefined ].indexOf(self.$refs[campo].$refs) === -1 && Object.keys(self.$refs[campo].$refs).length === 1 && [ '', null, undefined ].indexOf(self.$refs[campo].$refs[Object.keys(self.$refs[campo].$refs)[0]].onFocusField) === -1) {
            self.$refs[campo].$refs[Object.keys(self.$refs[campo].$refs)[0]].onFocusField()
          } else if (tentativa <= 10) {
            self.armArqGerGraficoRealizarFocusCampos(campo, (tentativa + 1))
          }
        }, (tentativa === 0 ? 0 : 200))
      }
    }
  }
}
</script>